"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTemplateProcessor = exports.DefaultTemplateProcessor = void 0;
const parts_js_1 = require("./parts.js");
class DefaultTemplateProcessor {
    handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === '.') {
            const committer = new parts_js_1.PropertyCommitter(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === '@') {
            return [new parts_js_1.EventPart(element, name.slice(1), options.eventContext)];
        }
        if (prefix === '?') {
            return [new parts_js_1.BooleanAttributePart(element, name.slice(1), strings)];
        }
        const committer = new parts_js_1.AttributeCommitter(element, name, strings);
        return committer.parts;
    }
    handleTextExpression(options) {
        return new parts_js_1.NodePart(options);
    }
}
exports.DefaultTemplateProcessor = DefaultTemplateProcessor;
exports.defaultTemplateProcessor = new DefaultTemplateProcessor();
